var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "calendar-stroke-field" },
    [
      _setup.enabled
        ? [
            _c(_setup.CalendarFieldTitle, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c(_setup.CInput, {
              attrs: {
                value: Number(_vm.width),
                type: "decimal",
                step: ".1",
                min: 0,
                label: "Width",
                disabled: _vm.disabled,
              },
              on: { input: _setup.onWidthChange },
            }),
            _vm._v(" "),
            _c(_setup.CalendarColorField, {
              attrs: { value: _vm.color, disabled: _vm.disabled },
              on: { input: _setup.onColorChange },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.CButton, {
        staticClass: "w-100",
        attrs: {
          variant: "secondary",
          text: _setup.enabled ? "Remove Stroke" : "Add Stroke",
          icon: _setup.enabled ? ["far", "trash"] : ["far", "plus"],
          disabled: _vm.disabled,
        },
        on: { click: _setup.toggle },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }